<div class="customer-data-management">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-header">
          <h2>客戶資料管理</h2>
          <p class="text-muted">管理企業客戶的環境配置、使用者資訊和模組設定</p>
        </div>

        <!-- 分頁導航 -->
        <div class="nav-tabs-container">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                [class.active]="activeTab === 'environment'"
                (click)="switchTab('environment')"
                type="button">
                <i class="fas fa-cog me-2"></i>公司管理
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                [class.active]="activeTab === 'users'"
                (click)="switchTab('users')"
                type="button">
                <i class="fas fa-users me-2"></i>使用者管理
              </button>
            </li>
          </ul>
        </div>

        <!-- 分頁內容 -->
        <div class="tab-content">
          <div class="tab-pane" [class.active]="activeTab === 'environment'">
            <app-environment-management
              *ngIf="activeTab === 'environment'"
              #environmentComponent></app-environment-management>
          </div>

          <div class="tab-pane" [class.active]="activeTab === 'users'">
            <app-customer-user-management *ngIf="activeTab === 'users'"></app-customer-user-management>
          </div>

          <!-- <div class="tab-pane" [class.active]="activeTab === 'modules'">
            <app-module-management
              *ngIf="activeTab === 'modules'"
              (moduleUpdated)="onModuleUpdated()"></app-module-management>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
